export interface PlanSettingModel {
  acode: number;
  plans: PlanSetting[];
}

export interface PlanSetting {
  Id?: string;
  id?: string;
  PlanName: string;
  Level: number;
  Package: string;
  Status: number;
  OrderInfoId: number;
  AccountPackageId: number;
  NodeTotal: number;
  NodeUsing: number;
  UsingDevices: number[];
  RemainDay: number;
  expirationDate?: any;
  Type?: any;
  Grade: number;
}

export interface PlanSettingParams {
  otp?: string;
  PlanInfoId: number;
  dcodes: any[];
}
